import { createAction, props } from '@ngrx/store';

export const NameEliquaCXChange = createAction(
  '[ELIQUA CX CONFIGURATION]: Name Eliqua CX Changed',
  props<{ nameEliquaCX: string }>(),
);

export const IntegrationCodeEliquaCXChange = createAction(
  '[ELIQUA CX CONFIGURATION]: Integration Code Eliqua CX Changed',
  props<{ integrationCodeEliquaCX: string }>(),
);

export const StatusEliquaCXChange = createAction(
  '[ELIQUA CX CONFIGURATION]: Status Eliqua CX Changed',
  props<{ isActiveEliquaCX: boolean }>(),
);

export const SchemaCodeEliquaCXChange = createAction(
  '[ELIQUA CX CONFIGURATION]: SchemaCode Eliqua CX Changed',
  props<{ schemaCodeEliquaCX: string }>(),
);

export const IdpAccountEliquaCXChange = createAction(
  '[ELIQUA CX CONFIGURATION]: IdpAccount Eliqua CX Changed',
  props<{ idpAccountEliquaCX: string }>(),
);

export const BaseUrlEliquaCXChange = createAction(
  '[ELIQUA CX CONFIGURATION]: Base URL EliquaCX Changed',
  props<{ baseUrlEliquaCX: string }>(),
);

export const UsernameEliquaCXChange = createAction(
  '[ELIQUA CX CONFIGURATION]: Username EliquaCX Changed',
  props<{ usernameEliquaCX: string }>(),
);

export const PasswordEliquaCXChange = createAction(
  '[ELIQUA CX CONFIGURATION]: Password EliquaCX Changed',
  props<{ passwordEliquaCX: string }>(),
);

export const SaveEliquaCXConfiguration = createAction(
  '[ELIQUA CX  CONFIGURATION]: Save EliquaCX Configuration',
);

export const SaveEliquaCXConfigurationSuccess = createAction(
  '[ELIQUA CX  CONFIGURATION]: Save EliquaCX Configuration Success',
  props<{ res: any }>(),
);

export const SaveEliquaCXConfigurationFailed = createAction(
  '[ELIQUA CX  CONFIGURATION]: Save EliquaCX Configuration Failed',
  props<{ error: any }>(),
);

export const UpdateEliquaCXConfiguration = createAction(
  '[ELIQUA CX  CONFIGURATION]: Update EliquaCX Configuration',
);

export const UpdateEliquaCXConfigurationSuccess = createAction(
  '[ELIQUA CX  CONFIGURATION]: Update EliquaCX Configuration Success',
  props<{ res: any }>(),
);

export const UpdateEliquaCXConfigurationFailed = createAction(
  '[ELIQUA CX  CONFIGURATION]: Update EliquaCX Configuration Failed',
  props<{ error: any }>(),
);

export const ToggleRootConfHelpTextStatus = createAction(
  '[ELIQUA CX  CONFIGURATION]: Toggle Root Configuration Help Text Status',
);

export const ToggleEndpointConfHelpTextStatus = createAction(
  '[ELIQUA CX  CONFIGURATION]: Toggle Endpoint Configuration Help Text Status',
);

export const ToggleCredentialsConfHelpTextStatus = createAction(
  '[ELIQUA CX  CONFIGURATION]: Toggle Credentials Configuration Help Text Status',
);

export const EditEliquaCXIntegrationSystem = createAction(
  '[ELIQUA CX CONFIGURATION]: Edit EliquaCX Integration System',
  props<{ eliquaCXData: any }>(),
);

export const CloseEliquaCXEditIntegration = createAction(
  '[ELIQUA CX CONFIGURATION]: Close EliquaCX Edit Integration',
);

export const EliquaCXSubmitData = createAction('[ELIQUA CX CONFIGURATION]: EliquaCX Submit Data');
